import { configureStore } from '@reduxjs/toolkit'
import merchant from "./slices/merchant";
import waitlist from "./slices/waitlist";
import feedback from './slices/feedback';
export default configureStore({
  reducer: { merchant, waitlist, feedback }
})